import React from "react"
import { useApplicationContext } from "context/applicationContext"

const OnlyWalmartAvailable: React.FC = ({ children }) => {
	const { isSupplier } = useApplicationContext()
	return <React.Fragment>{!isSupplier && children}</React.Fragment>
}

export { OnlyWalmartAvailable }
